import React from "react";
import Button from "../Button/Button.jsx";

// Compact prev/next pager shared by every paginated list/table in the app.
// page is 0-based; pageCount is the total number of pages. Renders nothing
// once everything fits on a single page.
const Pagination = ({ page, pageCount, onChange }) => {
  if (pageCount <= 1) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-5 py-3.5 border-t border-[var(--line)]">
      <div className="text-[13px] text-[var(--muted)]">
        Page {page + 1} of {pageCount}
      </div>
      <div className="flex items-center gap-1.5">
        <Button
          variant="ghost"
          size="sm"
          className="!text-xs !px-3 !py-1.5"
          onClick={() => onChange(Math.max(0, page - 1))}
          disabled={page === 0}
        >
          ← Previous
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="!text-xs !px-3 !py-1.5"
          onClick={() => onChange(Math.min(pageCount - 1, page + 1))}
          disabled={page >= pageCount - 1}
        >
          Next →
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
